import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { AlertTriangle } from 'lucide-react'

export const ProblemSection = () => {
  return (
    <section id="problem" className="py-24 bg-slate-50">
      <div className="container px-4 md:px-6 max-w-4xl mx-auto text-center">
        <ScrollReveal>
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 text-orange-600 mb-8">
            <AlertTriangle size={32} />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            A armadilha dos processos manuais
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            Excel, emails, mensagens e tarefas repetitivas consomem tempo, geram
            erros e criam dependência excessiva de pessoas específicas. As
            equipas passam mais tempo a registar informação do que a tomar
            decisões. Quando alguém falta ou sai da empresa, a operação abranda
            ou bloqueia.
          </p>
        </ScrollReveal>
      </div>
    </section>
  )
}
